(function() {

  function formatMoney(cents) {
    if (
      window.theme &&
      window.theme.Currency &&
      typeof window.theme.Currency.formatMoney === 'function'
    ) {
      return window.theme.Currency.formatMoney(
        cents,
        window.theme.settings.moneyFormat
      );
    }

    return '$' + (cents / 100).toFixed(2);
  }


  function initBruleQuickAdds(scope) {
    scope = scope || document;

    var forms = scope.querySelectorAll('[data-brule-quick-add]');

    forms.forEach(function(form) {

      if (form.dataset.bruleInitialized === 'true') {
        return;
      }

      var button = form.querySelector('.add-to-cart');

      if (button) {
        button.addEventListener('click', function(event) {
          event.stopPropagation();
        });
      }

      form.addEventListener('click', function(event) {
        event.stopPropagation();
      });

      if (
        window.theme &&
        typeof window.theme.AjaxProduct === 'function'
      ) {
        new window.theme.AjaxProduct(form);
        form.dataset.bruleInitialized = 'true';
      }

    });


    var selectors = scope.querySelectorAll('[data-brule-variant-select]');

    selectors.forEach(function(select) {

      if (select.dataset.bruleVariantInitialized === 'true') {
        return;
      }

      select.dataset.bruleVariantInitialized = 'true';

      select.addEventListener('click', function(event) {
        event.stopPropagation();
      });

      select.addEventListener('change', function(event) {

        event.stopPropagation();

        var actions = select.closest('[data-brule-product-actions]');

        if (!actions) {
          return;
        }

        var option = select.options[select.selectedIndex];

        if (!option) {
          return;
        }

        var variantId = option.dataset.variantId;
        var available = option.dataset.available === 'true';
        var price = parseInt(option.dataset.price || 0, 10);
        var comparePrice = parseInt(option.dataset.comparePrice || 0, 10);
        var imageUrl = option.dataset.image;

        var hiddenInput = actions.querySelector('[data-brule-variant-id]');
        var addButton = actions.querySelector('[data-brule-add-button]');
        var addText = actions.querySelector('[data-brule-add-text]');

        if (hiddenInput) {
          hiddenInput.value = variantId;
        }

        if (addButton) {
          addButton.disabled = !available;

          if (available) {
            addButton.classList.remove('disabled');
          } else {
            addButton.classList.add('disabled');
          }
        }

        if (addText) {
          addText.textContent = available ? 'Add to Cart' : 'Sold Out';
        }


        var card = actions.closest('.brule-product-card, .grid-product');

        if (!card) {
          return;
        }


        var priceContainer =
          card.querySelector('.brule-product-card__price') ||
          card.querySelector('.grid-product__price');

        if (priceContainer) {

          var priceHtml = '';

          if (comparePrice > price) {
            priceHtml +=
              '<span class="brule-product-card__compare-price">' +
              formatMoney(comparePrice) +
              '</span> ';
          }

          priceHtml +=
            '<span>' +
            formatMoney(price) +
            '</span>';

          priceContainer.innerHTML = priceHtml;
        }


        if (imageUrl) {

          var image =
            card.querySelector('.brule-product-card__image img') ||
            card.querySelector('.grid-product__image-mask img');

          if (image) {
            image.src = imageUrl;

            if (image.srcset) {
              image.removeAttribute('srcset');
            }
          }

        }

      });

    });

  }


  function runInit() {
    initBruleQuickAdds(document);
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      runInit
    );

  } else {

    runInit();

  }


  document.addEventListener(
    'page:loaded',
    runInit
  );


  document.addEventListener(
    'collection:reloaded',
    runInit
  );


  document.addEventListener(
    'shopify:section:load',
    function(event) {
      initBruleQuickAdds(event.target);
    }
  );


  window.BruleQuickAddInit =
    initBruleQuickAdds;

})();